const strings = {
  'username/sectionBanner/text': {
    en: 'CREATE A DISPLAY NAME',
    fr: 'CRÉATION D’UN NOM D’AFFICHAGE',
  },
  'username/header/text': {
    en: 'Create your display name for the NHL Hockey Challenge<sup>TM</sup> Leaderboard',
    fr: 'Choisissez un nom d’affichage pour le classement du Défi de hockey de la LNH<sup>MD</sup>',
  },
  'username/blurb/text': {
    en: `Your display name will be used as your identifier in the leaderboard.`,
    fr: `Votre nom d’affichage sera celui utilisé pour vous identifier dans le classement.`,
  },
  'username/saveButton/text': {
    en: `Save`,
    fr: `Enregistrer`,
  },
  'username/usernameLengthError/text': {
    en: `Please enter a name between 3-15 characters, using only letters, numbers or underscores (_).`,
    fr: `Veuillez saisir un nom qui comprend de 3 à 15 caractères, en utilisant uniquement des lettres, des chiffres ou des traits de soulignement (_).`,
  },
  'username/serverError/title': {
    en: 'Something went wrong',
    fr: 'Une erreur est survenue',
  },
  'username/serverError/text': {
    en: "Sorry, your display name couldn't be saved. Please try again.",
    fr: 'Désolé, votre nom d’affichage n’a pas pu être enregistré. Veuillez réessayer.',
  },
  'username/boomError/text': {
    en: (code) => {
      switch (code) {
        case 'hc.40':
          return 'That display name doesn’t meet our community standards. Please enter a different display name.';
        case 'hc.41':
          return 'That name is already in use. Please enter a different name.';
        default:
          return 'Error';
      }
    },
    fr: (code) => {
      switch (code) {
        case 'hc.40':
          return 'Ce nom d’affichage ne respecte pas nos normes communautaires. Veuillez entrer un autre nom d’affichage.';
        case 'hc.41':
          return 'Ce nom d’utilisateur est déjà utilisé. Veuillez saisir un nom d’utilisateur différent.';
        default:
          return 'Error';
      }
    },
  },
  'success/header/text': {
    en: "Lace your skates up, you're ready to play!",
    fr: 'Attachez vos patins, c’est l’heure de jouer!',
  },
  'success/button/text': {
    en: "Let's play",
    fr: 'Jouer',
  },
  'success/blurb/text': {
    en: 'You can start by selecting players for the first game day.',
    fr: 'Commencez par sélectionner des joueurs pour le premier jour de match.',
  },
  'success/logo/src': {
    en: '2025_tnhc_svg_en.svg',
    fr: '2025_tnhc_svg_fr.svg',
  },
  'update/username/heading': {
    en: 'Display name',
    fr: 'nom d’affichage',
  },
  'update/username/buttonText': {
    en: 'Update',
    fr: 'Modifier',
  },
  'update/username/success': {
    en: 'Your display name has been updated',
    fr: 'Votre nom d’affichage a été mis à jour',
  },
};

export default strings;
